import { Component, EventEmitter, Inject, inject, Input, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Browser } from '@capacitor/browser';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-help-header',
  templateUrl: './help-header.component.html',
  styleUrls: ['./help-header.component.scss'],
  standalone: false
})
export class HelpHeaderComponent {
  /** When false, hides the header back arrow. */
  @Input() showBackButton: boolean = true;
  @Input() logoSrc: string = 'assets/gub_logo_medium.jpg';
  @Input() logoClass: string = 'mh-50';
  /** When true, emits {@link backClick} instead of {@link NavController.back}. */
  @Input() delegateBackToParent = false;
  @Output() backClick = new EventEmitter<void>();

  constructor(private navCtrl: NavController) {}

  back() {
    if (this.delegateBackToParent) {
      this.backClick.emit();
      return;
    }
    this.navCtrl.back();
  }

  // Injecting DataService to send analytics event when help center is opened
  @Inject(DataService) private dataService: DataService = inject(DataService);
  async openHelpCenter() {
    this.dataService.sendEvent('help_centre', { source: 'help_header_component' });

    await Browser.open({
      url: 'https://getubettersupport.zendesk.com/hc/en-gb',
      windowName: '_blank'
    });
  }
}
